import Route from 'cio/routes/base';
import CrumbsService from 'cio/services/crumbs';
import { inject as service } from '@ember/service';

interface Params {
  message_id: string;
}

/* 
  The prettifyId method is a function that takes a single argument, messageId, which is expected to be a string.
  The function uses a regular expression to replace all instances of a hyphen or the start of the string followed
  by a non-hyphen character with a space followed by the uppercase version of that character. 
  This effectively converts a hyphenated identifier into a more human-readable format where each word is capitalized
  and separated by a space.

  Sample: 
  input: welcome-message -> output: Welcome Message
  input: hello-world -> output: Hello World
*/
const prettifyId = (messageId: string) => {
  return messageId.replace(/(-|^)([^-]?)/g, (_, prep, letter) => {
    return (prep != null && ' ') + letter.toUpperCase();
  });
};

export default class InAppMessagesMessageRoute extends Route {
  @service crumbs!: CrumbsService;

  crumb() {
    let params = this.paramsFor(this.routeName) as Params;
    let crumbName = params.message_id != null ? prettifyId(params.message_id) : '';
    return {
      name: crumbName,
      path: 'in-app-messages.message',
    };
  }

  model() {
    return {};
  }
}
